import React from 'react'
import { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export const useLogin = () => { 
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { dispatch } = useAuthContext();
    const navigate = useNavigate();

    const login = async (loginId, password) => {
        try {
            setIsLoading(true);
             // Reset error before making the API call

            const response = await fetch('https://api.immuniso.in/api/login/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: loginId, password }),
            });

            const json = await response.json();
            // Handle error status properly
          
            if (!response.ok) { 
                toast.error(json.message)
            } else {
                Cookies.set('accessToken', json.data.tokens.access, { expires: 2 });
                dispatch({ type: 'LOGIN', payload: json });
                toast?.success(json?.message)
                setTimeout(() =>{
                    navigate('/')
                },1200)
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    };


    return { login, isLoading, error };
};


export default useLogin